import type { ReactNode } from 'react';

interface PanelItemsSectionProps {
  title?: string;
  className?: string;
  children: ReactNode;
}

const PanelItemsSection = (props: PanelItemsSectionProps) => {
  const { title, className = '', children } = props;
  return (
    <div className={`flex flex-col ${className}`}>
      {title && (
        <div className="flex flex-row items-center justify-between px-3 py-2">
          <div className="text-base-medium">{title}</div>
        </div>
      )}
      <div className="flex-row overflow-hidden rounded-xl bg-white [&>div:not(:last-child)]:border-0 [&>div:not(:last-child)]:border-neutral-6 [&>div:not(:last-child)]:border-b-thin [&>div:not(:last-child)]:border-solid">
        {children}
      </div>
    </div>
  );
};

export default PanelItemsSection;
